<template>
  <div>
    <page-header>
      <div class="text-nowrap c-black ml-3 mr-3" style="color: black">
        <h4 class="form-check-label">User Settings</h4>
      </div>

      <div class="badgebutton active text-nowrap c-white ml-4">
        <router-link class="ml-1 mt-3 mb-2" :to="{ name: 'Boards' }">
          <i class="far fa-caret-left"></i>
          Back to Landing Page
        </router-link>
      </div>
    </page-header>

    <div class="container-fluid p-3">
      <div class="d-flex">
        <div class="settingsmenu bg-white rounded-left shadow-sm mt-2 mb-2">
          <router-link
            tag="div"
            class="menuitem"
            :class="{ active: $route.name === routes.notificationsettings }"
            :to="{
              name: routes.notificationsettings,
            }"
          >
            <i class="far fa-bells"></i>
            <div class="nav-item-title">Notifications</div>
          </router-link>
        </div>
        <div class="bg-lightgray rounded-sm flex-grow-1 p-4 pl-5 pt-4 shadow-sm settingscontainer shadow-sm">
          <div style="min-width: 800px; max-width: 1550px">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import PageHeader from '@/components/PageHeader.vue';
  import BoardSettings from '@/components/Board/BoardSettings.vue';
  import RouteNames from '@/types/routeNames';
  import { UserModule, UserStore } from '@/store/user';

  @Component({
    components: {
      PageHeader,
      BoardSettings,
    },
  })
  export default class UserSettings extends Vue {
    private userStore: UserModule = UserStore;
    routes = RouteNames;

    mounted() {
      if (!this.userStore.user) {
        this.$router.push({ name: 'Boards' });
      }
    }
  }
</script>
